let linksColumn = [
    {
        title: 'Conoce Jumbo',
        links: [
            {
                title: 'Beneficios Jumbo.cl',
                url: '/institucional/beneficios',
                target: ''
            },
            {
                title: 'Concursos y Promociones',
                url: '/institucional/concursos',
                target: ''
            },
            /*{
                title: 'Compromisos',
                url: '/institucional/compromisos',
                target: ''
            },*/
            {
                title: 'Productos Jumbo',
                url: '/busca?fq=H:137',
                target: ''
            },
            {
                title: 'Código de Ética',
                url: 'https://assets.jumbo.cl/uploads/2019/07/codigo-etica-grupo-cencosud.pdf',
                target: '_blank'
            }
        ]
    },
    {
        title: 'Servicios',
        links: [
            {
                title: 'Contáctanos',
                url: '/institucional/contacto',
                target: ''
            },
            {
                title: 'Nuestros servicios',
                url: '/institucional/servicios',
                target: ''
            },
            {
                title: 'Zonas de Despacho',
                url: '/institucional/servicios?s=online-house&q=3',
                target: ''
            },
            {
                title: 'Locales Jumbo',
                url: '/institucional/locales-jumbo',
                target: '_self'
            },
            {
                title: 'Consulta tu Boleta',
                url: 'https://cencosud.paperless.cl/BoletaJumbo/',
                target: '_blank'
            },
            {
                title: 'Tarjeta Cencosud',
                url: 'https://www.tarjetacencosud.cl/TarjetaMasWEB/inicio.do?utm_source=jumbo_cl&utm_medium=Footer&utm_content=rfcl&utm_campaign=Marca',
                target: '_blank'
            },
            {
                title: 'Seguros',
                url: 'https://www.seguroscencosud.cl/vseg-paris/index.jsp?utm_source=Jumbo&utm_medium=footer&utm_campaign=footer-Seguros_04-2013',
                target: '_blank'
            },
            {
                title: 'Informaciones',
                url: '/informaciones',
                target: '_self'
            },
        ]
    },
    {
        title: 'Nuestra Empresa',
        links: [
            {
                title: 'Cencosud',
                url: 'https://www.cencosud.com/',
                target: '_blank'
            },
            {
                title: 'Easy',
                url: 'https://www.easy.cl',
                target: '_blank'
            }, 
            {
                title: 'Paris',
                url: 'https://www.paris.cl',
                target: '_blank'
            },
            {
                title: 'Santa Isabel',
                url: 'https://www.santaisabel.cl/',
                target: '_blank'
            },
            {
                title: 'Trabaja con Nosotros',
                url: 'https://cencosud.trabajando.com/',
                target: '_blank'
            },
            {
                title: 'Giftcard',
                url: 'https://www.giftcard.cl/',
                target: '_blank'
            },
        ]
    },
    {
        title: 'Puntos Cencosud',
        links: [
            {
                title: 'Inscríbete',
                url: 'https://www.puntoscencosud.cl/inscripcion/index.html?utm_source=Inscripcion%20UDN&utm_medium=referral&utm_campaign=UDN%20JUMBO.cl',
                target: '_blank'
            },
            {
                title: 'Revisa tus puntos',
                url: 'https://www.puntoscencosud.cl/portal/faces/consultar-puntos?utm_source=Banner_UDN&amp;utm_medium=Banner&amp;utm_campaign=Jumbo&amp;_afrLoop=945351832790671&amp;_afrWindowMode=0&amp;_afrWindowId=littleWindow#!%40%40%3Futm_medium%3DBanner%26_afrWindowId%3DlittleWindow%26utm_source%3DBanner_UDN%26utm_campaign%3DJumbo%26_afrLoop%3D945351832790671%26_afrWindowMode%3D0%26_adf.ctrl-state%3Dz9trlxowo_14',
                target: '_blank'
            }
        ],
        child: [
            {
                title: 'Servicio a empresas',
                links: [
                    {
                        title: 'Proveedores',
                        url: '/institucional/proveedores',
                        target: '_self'
                    }
                ],
            }
        ]
    },
    
];

export default linksColumn;



